// Que mapa dibuja la torre (ADR-020, G6) y el portal del proveedor (PP-51).
// Logica pura: recibe las variables de build como un registro y decide, sin
// tocar import.meta ni el DOM. Vive en @ucorp/web-map desde PP-51 para que las
// dos superficies decidan igual.
//
// Orden de precedencia:
// 1. Clave web Y Map ID de Google presentes: Google Maps JavaScript. Es el
//    destino de ADR-020 y gana siempre, asi que cargar la clave en el build
//    (G2) alcanza para pasar de mapa sin tocar otra variable.
// 2. Sin Google y con VITE_MAP_PROVIDER=maplibre: el mapa propio de PB-10
//    (ADR-016), solo como convivencia hasta G7. Tiene que pedirse de forma
//    explicita: un build al que le falta la clave no vuelve a MapLibre por
//    omision, porque MapLibre no puede dibujar lugares de Google (ADR-020 R1).
// 3. Si no: "mapa no configurado". La torre sigue operando sin mapa.
//
// Una clave sin Map ID (o al reves) cuenta como no configurado: el Map ID es
// el que trae el estilo oscuro y el render vectorial que pide ADR-020, y un
// mapa claro de Google por defecto seria un requisito incumplido en silencio.
export const GOOGLE_MAPS_KEY_VAR = "VITE_GOOGLE_MAPS_KEY";
export const GOOGLE_MAP_ID_VAR = "VITE_GOOGLE_MAP_ID";
export const MAP_PROVIDER_VAR = "VITE_MAP_PROVIDER";
function readVar(env, name) {
    const value = env[name];
    return typeof value === "string" ? value.trim() : "";
}
export function resolveMapProvider(env, options = {}) {
    const apiKey = readVar(env, GOOGLE_MAPS_KEY_VAR);
    const mapId = readVar(env, GOOGLE_MAP_ID_VAR);
    if (apiKey !== "" && mapId !== "")
        return { kind: "google", apiKey, mapId };
    if (options.allowMapLibre !== false && readVar(env, MAP_PROVIDER_VAR).toLowerCase() === "maplibre")
        return { kind: "maplibre" };
    const missing = [];
    if (apiKey === "")
        missing.push(GOOGLE_MAPS_KEY_VAR);
    if (mapId === "")
        missing.push(GOOGLE_MAP_ID_VAR);
    return { kind: "not-configured", missing };
}
//# sourceMappingURL=mapProvider.js.map